var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUnsaveAll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00146 7.16797H5.77907H19.9999",
    stroke: "#D92440",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44521 7.16751V5.38991C8.44521 4.91846 8.6325 4.46632 8.96586 4.13295C9.29923 3.79959 9.75137 3.6123 10.2228 3.6123H13.778C14.2495 3.6123 14.7016 3.79959 15.035 4.13295C15.3683 4.46632 15.5556 4.91846 15.5556 5.38991V7.16751M18.222 7.16751V19.6107C18.222 20.0822 18.0348 20.5343 17.7014 20.8677C17.368 21.2011 16.9159 21.3883 16.4444 21.3883H7.55641C7.08496 21.3883 6.63282 21.2011 6.29946 20.8677C5.96609 20.5343 5.77881 20.0822 5.77881 19.6107V7.16751H18.222Z",
    stroke: "#D92440",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2227 11.6113V16.9441",
    stroke: "#D92440",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7793 11.6113V16.9441",
    stroke: "#D92440",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnsaveAll);
export default __webpack_public_path__ + "static/media/ic_unsave_all.1d71e80d21dd409a09d14483279d3e9f.svg";
export { ForwardRef as ReactComponent };